import classes from "./LoginSignUpSwitch.module.css";
import { cn } from "@/lib/utils";
import { NavLink } from "react-router-dom";
import ROUTES from "@/data/Routes";

const LoginSignUpSwitch = ({ variant = "pill" }: { variant?: "pill" | "plain" }) => {
  return (
    <div
      className={cn(
        variant === "plain" ? classes.switchPlain : classes.switch,
      )}
    >
      <NavLink
        to={ROUTES.LOGIN}
        end
        className={cn(
          variant === "plain" ? classes.linkPlain : classes.link,
        )}
      >
        <span>Prisijungti</span>
      </NavLink>
      <span
        aria-hidden="true"
        className={cn(variant === "plain" ? classes.divider : "hidden")}
      />
      <NavLink
        to={ROUTES.REGISTER}
        className={cn(
          variant === "plain" ? classes.linkPlain : classes.link,
        )}
      >
        <span>Registruotis</span>
      </NavLink>
    </div>
  );
};

export default LoginSignUpSwitch;
